import api from './apiService';  
import apiRoutes from './apiRoutes';

export const getAllMessagesSubjectAsync = async () => {
  try {
    const response = await  api.get(apiRoutes.supportMessages.getAllMessagesSubject);
      return response.result;  
  } catch (error) {
    throw error;
  }
}; 

export const sendSupportMessage = async (messageObject) => {
    try {
      const response = await  api.post(apiRoutes.supportMessages.sendMessage, messageObject);
        return response.result;  
    } catch (error) {
      throw error;
    }
  }; 